module.exports = vendors;


//////////////////
// WEBPACK FOOTER
// external "vendors"
// module id = 13
// module chunks = 23